import { handleAction } from 'redux-actions'
import { updateUser } from '../actions/auth'

export const defaultState = null

export default handleAction(updateUser, {
	next: (state, action) => action.payload,
}, defaultState)



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js